"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { getInitialsFromString } from './lib/getInitialsFromString.mjs';
import styles from './Initials.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import { onlyText } from 'react-children-utilities';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { getColorFromInitials } from './lib/getColorFromInitials.mjs';

const Initials = flowComponent("Initials", (props) => {
  const {
    children,
    useDynamicColor = false,
    className,
    "aria-hidden": ariaHidden,
    ref
  } = props;
  const textContent = onlyText(children);
  const initials = getInitialsFromString(textContent);
  const dynamicColor = useMemo(
    () => useDynamicColor ? getColorFromInitials(textContent) : void 0,
    [useDynamicColor, textContent]
  );
  const rootClassName = clsx(styles.initials, className);
  const initialsElements = initials.map((initial, index) => /* @__PURE__ */ jsx("span", { children: initial }, index));
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-dynamic-color": dynamicColor,
      "aria-hidden": ariaHidden,
      "aria-label": textContent,
      className: rootClassName,
      ref,
      children: initialsElements
    }
  ) });
});

export { Initials, Initials as default };
//# sourceMappingURL=Initials.mjs.map
